document.addEventListener('DOMContentLoaded', function () {
    const options = document.querySelectorAll('.card__product--label');

    options.forEach(option => {
      option.addEventListener('click', function () {
        console.log("Se dio click en add to cart size")
        const parentForm = option.closest('form');
        if (parentForm) {
          const submitButton = parentForm.querySelector('.js-go-cart-add-to-cart.quick-add__submit');

          if (submitButton) {
            setTimeout(() => {
              submitButton.click();
            }, 400);
          }
        }
      });
    });
  });
  

  const buttonsSelectorSize = document.querySelectorAll(".cta-selector-size");
    buttonsSelectorSize.forEach((button) => {
      button.addEventListener("click", () => {
        const parent = button.parentElement;
        const targetElement = parent.querySelector('product-form');
        if (targetElement) {
          targetElement.classList.add("show-element-PDM");
          button.classList.add("black-color-mobile");
          console.log(targetElement)
        }
    });
});